module.exports = __webpack_public_path__ + "static/img/byyl-logo1.ad8b1b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/byyl-logo1.png
// module id = aNRk
// module chunks = 24